module.exports = __webpack_public_path__ + "assets/img/97514da690a52f5a276485be245ad1aa.png";